import { EN_SITE_API_BASE } from '../api/settings';
import {GetRequest} from '../lib/request';

const GET_MY_LICENSES_PATH = `/my-account/create-app-key/api/get-my-licenses/`;
const CREATE_KEY_PATH = `/my-account/create-app-key/api/create-key/`;

export async function getMyLicenses(customerid: string) {
  try{
    return await GetRequest(`${GET_MY_LICENSES_PATH}${customerid}`);
  }catch(ex){
    throw new Error("Unable to fetch licenses from remote server.")
  }
}

export async function createKey(data: object){
  const config = {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  }
  let key = await fetch(`${CREATE_KEY_PATH}`, config)
  .then(response => { 
    if(!response.ok){
      throw new Error("Server Error")
    }else return response.json();
  })
  .then(json => {
    if(json.Code === 0){
      return json;
    }else{
      throw new Error(json.Value);
    }
  })
  .catch(e => {
      throw e;
  });

  return key;

}